export const DATE_FORMAT = 'YYYY-MM-DD';
export const DIS_DATE_FORMAT = 'mm/dd/yyyy';
export const DIS_DATE_FORMAT_NEW = 'DD-MM-YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDThh:mm';

export const DATE_MONTH_FORMAT = 'DD/MM/YYYY';

export const DATE_TIME_FORMAT_NEW = 'YYYY-MM-DD HH:mm:ss';
